import React, { useState } from "react";
import PageWrapper from "../components/PageWrapper";
import { motion } from "framer-motion";

export default function Contact() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("access_key", "da914651-1f1a-4ba7-b8e6-14d4c3ca327c");
    formData.append("subject", "New Contact Request from Website");
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("message", form.message);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        alert("Message sent successfully!");

        setForm({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        alert("Failed to send message.");
      }
    } catch (error) {
      console.error(error);
      alert("Error sending message.");
    }
  };

  return (
    <PageWrapper>

      {/* HERO */}
      <section className="bg-gradient-to-br from-blue-700 via-purple-700 to-indigo-700 text-white pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold uppercase tracking-wide">
            CONTACT US
          </h1>
          <p className="text-lg opacity-90 mt-4 max-w-2xl mx-auto">
            Reach us for enquiries, support, business partnership, or demo requests.
          </p>
        </div>
      </section>

      {/* CONTACT BODY */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12">

          {/* LEFT — INFO CARDS */}
          <div className="space-y-8">

            {/* OFFICE ADDRESS CARD */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="p-8 rounded-xl shadow-xl border bg-white relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-200/30 via-purple-200/30 to-pink-200/30 blur-2xl"></div>

              <div className="relative z-10">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  📍 Office Address
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Kilakarai – 623517<br />
                  Tamil Nadu, India
                </p>
              </div>
            </motion.div>

            {/* SUPPORT CARD */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="p-8 rounded-xl shadow-xl border bg-white relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-200/40 via-purple-200/40 to-blue-200/40 blur-2xl"></div>

              <div className="relative z-10">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  📞 Support & Helpline
                </h3>
                <p className="text-gray-700 text-lg">9008747991</p>
                <p className="text-gray-700 text-lg">9596564910</p>
                <p className="text-gray-600 text-sm mt-2">
                  (Available Mon–Sat, 10 AM – 6 PM)
                </p>
              </div>
            </motion.div>

            {/* BUSINESS / PARTNERSHIP */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="p-8 rounded-xl shadow-xl border bg-white relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-200/40 via-orange-200/40 to-red-200/40 blur-2xl"></div>

              <div className="relative z-10">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  🤝 Business / Partnership
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Email: <span className="font-semibold">myschoolapp001@gmail.com</span>
                </p>
                <p className="text-gray-700">
                  Want dealership, collaboration, or school onboarding?
                  <br />We’re happy to assist.
                </p>
              </div>
            </motion.div>

          </div>

          {/* RIGHT — FORM */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-white p-8 rounded-xl shadow-xl border border-gray-100"
          >
            <h2 className="text-3xl font-bold text-gray-800 mb-6">
              Send us a Message
            </h2>

            <form className="space-y-5" onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500"
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500"
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={form.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500"
              />

              <textarea
                rows="5"
                name="message"
                placeholder="Message"
                value={form.message}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500"
              ></textarea>

              <button
                type="submit"
                className="w-full py-3 bg-blue-600 text-white font-bold rounded-lg shadow-lg hover:bg-blue-700 transition"
              >
                Send Message
              </button>

            </form>
          </motion.div>

        </div>
      </section>
    </PageWrapper>
  );
}